document.addEventListener('DOMContentLoaded', function () {
  const menus = document.querySelectorAll('.hoe-mega-menu');

  menus.forEach(function (menu) {
    const links = menu.querySelectorAll('.hoe-mega-sidebar-link');
    const panels = menu.querySelectorAll('.hoe-mega-panel');

    function activateDepartment(index) {
      links.forEach(function (link) {
        link.classList.remove('is-active');
      });

      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
      });

      const activeLink = menu.querySelector(
        '.hoe-mega-sidebar-link[data-hoe-menu="' + index + '"]'
      );

      const activePanel = menu.querySelector(
        '.hoe-mega-panel[data-hoe-panel="' + index + '"]'
      );

      if (activeLink) {
        activeLink.classList.add('is-active');
      }

      if (activePanel) {
        activePanel.classList.add('is-active');
      }
    }

    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        activateDepartment(this.dataset.hoeMenu);
      });

      link.addEventListener('focus', function () {
        activateDepartment(this.dataset.hoeMenu);
      });
    });

    menu.addEventListener('mouseleave', function () {
      activateDepartment('0');
    });
  });
});